import SettingsInputComponentIcon from "@material-ui/icons/SettingsInputComponent";

import Create from "views/TopUpLimitConfiguration/Create";
import Delete from "views/TopUpLimitConfiguration/Delete";
import Edit from "views/TopUpLimitConfiguration/Edit";
import List from "views/TopUpLimitConfiguration/List";

import { token } from "functions/Helper";

const topUpLimitConfiguration = () => {
  let views = [];

  if (
    token["creditmonitoring.top_up_limit_configurations.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/TopUpLimitConfigurations/List",
      name: "Top Up Limit Configurations",
      icon: SettingsInputComponentIcon,
      component: List,
      layout: "/admin"
    });

  return views;
};

const topUpLimitConfigurationHidden = () => {
  let views = [];

  if (
    token["creditmonitoring.top_up_limit_configurations.create"] ===
      "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/TopUpLimitConfigurations/Create",
      name: "Create Top Up Limit Configuration",
      component: Create,
      layout: "/admin"
    });

  if (
    token["creditmonitoring.top_up_limit_configurations.update"] ===
      "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/TopUpLimitConfigurations/Edit",
      name: "Edit Top Up Limit Configuration",
      component: Edit,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });

  if (
    token["creditmonitoring.top_up_limit_configurations.delete"] ===
      "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/TopUpLimitConfigurations/Delete",
      name: "Delete Top Up Limit Configuration",
      component: Delete,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Top Up Limit Configuration Hidden",
        state: "topUpLimitConfigurationHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { topUpLimitConfiguration, topUpLimitConfigurationHidden };
